import {StoreStateType} from 'modules'
import {bookingCreationListener} from 'modules/bookingCreation/listener'
import {paymentSettingsListener} from 'modules/paymentSettings/listener'
import {Middleware} from 'redux'

import coreAnalytics from '@vio/core/src/analytics/modules/middleware'
import {afterAuthRedirection} from '@vio/core/src/auth/modules/middleware'
import {bookApi as bookApiCore} from '@vio/core/src/booking/services/bookApi'
import {bookingRetrieveApi as bookingRetrieveApiCore} from '@vio/core/src/booking/services/bookingRetrieveApi'
import {localizationApi} from '@vio/core/src/localization/business/getCountriesList'
import {offerCheckApi as offerCheckApiCore} from '@vio/core/src/offer/services/offerCheckApi'
import {offerConfigurationApi} from '@vio/core/src/offer/services/offerConfigurationApi'
import {paymentSettingsApi} from '@vio/core/src/offer/services/paymentSettingsApi'
import {searchApi as searchApiCore} from '@vio/core/src/sapi/services/searchApi'
import {trustpilotApi} from '@vio/core/src/trustpilotWidget/services/trustpilotApi'
import {dealFreezeMiddleware} from '@vio/shared/src/dealFreeze/modules/middleware'
import {dealFreezeApi as dealFreezeApiCore} from '@vio/shared/src/dealFreeze/services/dealFreezeApi'
import {priceWatchApi} from '@vio/shared/src/priceWatch/services'
import {notificationPreferencesApi} from '@vio/shared/src/user/notificationPreferences/modules'

import analytics from './sideEffects/analytics'
import bookApi from './sideEffects/bookApi'
import retrieveBookingApi from './sideEffects/bookingRetrieveApi'
import browser from './sideEffects/browser'
import localization from './sideEffects/localization'
import offerCheckApi from './sideEffects/offerCheckApi'
import overlay from './sideEffects/overlay'
import psd2Auth from './sideEffects/psd2Auth'
import searchApi from './sideEffects/searchApi'

export type MiddlewareType = Middleware<StoreStateType>

const middlewareList = [
  bookingCreationListener.middleware,
  paymentSettingsListener.middleware,
  notificationPreferencesApi.middleware,
  bookApiCore.middleware,
  offerCheckApiCore.middleware,
  searchApiCore.middleware,
  dealFreezeApiCore.middleware,
  localizationApi.middleware,
  offerConfigurationApi.middleware,
  bookingRetrieveApiCore.middleware,
  paymentSettingsApi.middleware,
  priceWatchApi.middleware,
  trustpilotApi.middleware,
  localization,
  overlay,
  browser,
  analytics,
  psd2Auth,
  coreAnalytics,
  offerCheckApi,
  searchApi,
  bookApi,
  retrieveBookingApi,
  dealFreezeMiddleware,
  afterAuthRedirection
]

export default middlewareList
